import React from "react";

export const InfoSection = () => {
  const post = {
    title: "SEPARA TU CUPO CON S/. 30.00",
    text: `
      Puedes inscribirte y elegir donde realizaras tu proyecto misionero, ingresa a viajes e informate, el monto total de las inscripciones es segun el lugar del proyecto: AREQUIPA (425.00), TUMBES, TACNA Y PUNO (450.00), estamos en periodo de precio regular hasta el 11 de diciembre , puedes ir pagando de poco a poco, incluso hasta el mismo dia del campamento , despues del 11 de diciembre el costo de la inscripción aumentará a extemporaneo.
    `,
    image:
      "https://thumbs-us-east-1.myalbum.io/photo/1k0/67087c5c-f3a9-47a5-ae93-ca8f9504290b.jpg",
  };

  return (
    <section
      className="container-fluid espacio-home"
      style={{
        backgroundColor: "#101010",
      }}
    >
      <div className="container">
        {/* POST ÚNICO */}
        <div className="row align-items-center g-lg-3 g-2 ">
          <h1 className="fw display-10 miTitulo mb-3">Lo Último !</h1>
          {/* IMAGEN */}
          <div className="col-lg-7">
            <div
              className="overflow-hidden shadow-lg"
              style={{
                borderRadius: "30px",
              }}
            >
              <img
                src={post.image}
                alt={post.title}
                className="img-fluid w-100 foto-ultimo"
                style={{
                  height: "500px",
                  objectFit: "cover",
                  transition: "0.4s",
                }}
              />
            </div>
          </div>

          {/* CONTENIDO */}
          <div className="col-lg-5 text-white">
            <h2
              className="fw mb-4"
              style={{
                fontSize: "clamp(2rem, 1.5vw, 3rem)",
                lineHeight: "1.2",
                textAlign: "center",
                fontFamily: '"Bebas Neue", sans-serif',
              }}
            >
              {post.title}
            </h2>

            <p
              style={{
                fontSize: "19px",
                lineHeight: "1.3",
                opacity: 0.92,
                textAlign: "justify",
              }}
            >
              {post.text}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
